import React, { FC, useEffect } from 'react';
import {
    PushkinConfiguration,
    useWorkExperience,
    WorkExperienceSection,
    SafeWrapper,
} from '@fiverr-private/seller_pages_toolbox';
import { useMonitoring } from '../../../monitoring';
import { StickyHeader } from '../StickyHeader';

import styles from './index.module.scss';

interface FreelancerWorkExperienceProps {
    pushkinConfiguration?: PushkinConfiguration;
}

const FreelancerWorkExperience: FC<FreelancerWorkExperienceProps> = ({ pushkinConfiguration }) => {
    const { fireEvents, Providers } = useMonitoring();
    const { showWorkExperience } = useWorkExperience();

    useEffect(() => {
        if (showWorkExperience) {
            fireEvents({
                [Providers.Mixpanel]: {
                    type: 'Seller work experience exists',
                },
            });
        }
    }, [showWorkExperience, Providers.Mixpanel, fireEvents]);

    if (!showWorkExperience) {
        return null;
    }

    return (
        <div className={styles.workExperience} id={StickyHeader.TabName.WorkExperience}>
            <WorkExperienceSection pushkinConfiguration={pushkinConfiguration} />
        </div>
    );
};

const SafeFreelancerWorkExperience = SafeWrapper(FreelancerWorkExperience, 'FreelancerWorkExperience');

export { SafeFreelancerWorkExperience as FreelancerWorkExperience };
export default SafeFreelancerWorkExperience;
